import { Capacitor } from '@capacitor/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMediaQuery } from 'usehooks-ts'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { breakpoints } from '@/config/layout'
import { LogOutAction } from '@/modules/auth/components/log-out-action'
import { useSubjectName } from '@/modules/trust/hooks/useSubjectName'
import { isIntramuros } from '@/utils/intramuros'
import { BannerContainer } from './MandateBanner.styled'

import type { ComponentPropsWithoutRef } from 'react'

export type MandateBannerProps = ComponentPropsWithoutRef<'div'>

export const MandateBanner = (props: MandateBannerProps) => {
  const name = useSubjectName()
  const isMobile = useMediaQuery(breakpoints.toS) || Capacitor.isNativePlatform()

  return (
    <BannerContainer {...props} isMobile={isMobile}>
      <Span type='BodyMediumRegular'>Voor {name}</Span>
      {!isIntramuros && (
        <LogOutAction>
          <FontAwesomeIcon icon={['fal', 'arrows-repeat']} />
        </LogOutAction>
      )}
    </BannerContainer>
  )
}
